<template>
    <div>
        <category-form @toggleIsDisabled="toggleIsDisabled" @readyToSave="readyToSave"></category-form>

        <div class="d-flex justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled">Save</button>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import CategoryForm from './CategoryForm'

    export default {
        data: function() {
            return {
                isDisabled: true,
                updatedForm: null,
            }
        },
        created: function() {
            this.updatedForm = this.getSelectedItem ? JSON.parse(JSON.stringify(this.getSelectedItem)) : {};
        },
        methods: {
            ...mapActions([
                'closeModal',
                'updateItem',
                'clearSelectedItem'
            ]),
            toggleIsDisabled: function(isDisabled) {
                this.isDisabled = isDisabled;
            },
            cancel: function() {
                this.clearSelectedItem();
                this.closeModal();
            },
            readyToSave: function(updatedForm) {
                this.updatedForm = updatedForm;
            },
            save: function() {
                this.updateItem({
                    object: 'category',
                    action: 'edit',
                    table: 'categories',
                    fields: { supplierId: this.account.supplierId, category: this.updatedForm }
                });
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'account',
            ])
        },
        components: {
            CategoryForm,
        }
    }
</script>



// WEBPACK FOOTER //
// CategoryEdit.vue?245f1ae1